import React from "react"
import LogoSlider from "../../Slider/LogoSlider"

function HomeSection1() {
    return (
        <section className="bg-[#050508] px-6 md:px-20 py-1 md:py-1">
            {/* LEFT-ALIGNED HEADING */}
         

            <LogoSlider />
        </section>
    )
}

export default HomeSection1
